const JWT_MIN_PARTS = 3; // header.payload.signature

function isValidJwtShape(token: string): boolean {
  return typeof token === "string" && token.trim() !== "" && token.split(".").length >= JWT_MIN_PARTS;
}

export default function jwt2json(token: string): Record<string, unknown> {
  if (!isValidJwtShape(token)) {
    return {};
  }
  const parts = token.split(".");
  const base64Url = parts[1];
  if (!base64Url) {
    return {};
  }
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );
  return JSON.parse(jsonPayload) as Record<string, unknown>;
}

/**
 * Returns the tenant JWT to use when deriving appId (e.g. for SocialLoginButtons).
 * Prefers window.__TENANT__.token from bootstrap.js when valid; falls back to REACT_APP_TOKEN for local/dev.
 */
export function getTenantTokenForAppId(): string | undefined {
  if (typeof window !== "undefined" && window.__TENANT__?.token) {
    const tenantToken = window.__TENANT__.token;
    if (
      typeof tenantToken === "string" &&
      tenantToken !== "none" &&
      tenantToken.trim() !== "" &&
      tenantToken.split(".").length >= JWT_MIN_PARTS
    ) {
      return tenantToken;
    }
  }
  return process.env.REACT_APP_TOKEN;
}
